import jwtDecode from 'jwt-decode';

const TOKEN_KEY = 'user_token';

export const setToken = (token) => {
    localStorage.setItem(TOKEN_KEY, token);
};

export const getToken = () => {
    return localStorage.getItem(TOKEN_KEY);
};

export const removeToken = () => {
    localStorage.removeItem(TOKEN_KEY);
};

export const isAuthenticated = () => {
    return !!getToken();
};

/**
 * Roles del administrador autenticado, leídos del propio JWT.
 *
 * Lexik mete `roles` en el payload por defecto (`JWTManager::create()` en `hrbot_back`), y
 * `User::getRoles()` devuelve ahí `ROLE_ADMIN` más el rol concreto del `AdminUser`
 * (`ROLE_ADMIN_ROOT`, `ROLE_ADMIN_PRODUCT`, `ROLE_ADMIN_CS`, `ROLE_ADMIN_FINANCE`).
 *
 * Esto solo sirve para decidir qué se pinta: la autorización de verdad la hace el backend.
 */
export const getTokenRoles = () => {
    const token = getToken();
    if (!token) {
        return [];
    }

    try {
        const { roles } = jwtDecode(token);
        return Array.isArray(roles) ? roles : [];
    } catch (e) {
        return [];
    }
};

export const hasAnyRole = (allowedRoles = []) => {
    const roles = getTokenRoles();
    return allowedRoles.some((role) => roles.includes(role));
};
